import { all, call, put, takeEvery } from 'redux-saga/effects';
import { fetchDealsBySourceId, FetchDealsResult } from '../../modules/deals/api';
import { fetchDeals, fetchDealsFailure, fetchDealsSuccess } from './slice';

export function* handleFetchDeals({ payload: accountId }: ReturnType<typeof fetchDeals>) {
  try {
    const { success, error, json }: FetchDealsResult = yield call(fetchDealsBySourceId, accountId);
    if (success && json) {
      yield put(fetchDealsSuccess(json));
    } else {
      yield put(fetchDealsFailure(error!));
    }
  } catch (err) {
    const error = err instanceof Error ? err.message : JSON.stringify(err);
    yield put(fetchDealsFailure(error));
  }
}

export function* dealsSaga() {
  yield all([takeEvery(fetchDeals.type, handleFetchDeals)]);
}
